import React, { useState } from 'react';

import { ReactComponent as LensSVG } from '../../assets/icons/search.svg';
import { useRoot } from '../../context/RootProvider';
import { Button, Input, Typography } from '../../designComponents';
import IndividualUserMessageWrapper from '../../designComponents/IndividualUserMessageWrapper';
import { VisibleScreenType } from '.';
import { messageData } from './messageData';
import { RoleWiseUserGroupContainer, UserListContainer } from './style';

type Props = {
  changeVisibleScreen?: (value: VisibleScreenType) => void;
};

const UserList = ({ changeVisibleScreen }: Props) => {
  const [searchText, setSearchText] = useState('');

  const { auth } = useRoot();

  const handleSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchText(value);
  };

  return (
    <UserListContainer>
      <Input
        iconLeft={<LensSVG />}
        className="search-user"
        onChange={handleSearchTextChange}
        value={searchText}
        name="seaechUser"
        containerStyle={{
          borderRadius: '6px',
          padding: '5px 14px',
        }}
        placeholder="Search"
      />
      {auth?.role === 'PRINTER' ? (
        <>
          {messageData.map((data, index) => (
            <IndividualUserMessageWrapper
              key={index}
              onclick={() =>
                changeVisibleScreen && changeVisibleScreen('conversation')
              }
              name={data.name}
              lastMessage={data.lastMessage}
              lastMessageDate={data.lastMessageDate}
              isOnline={index % 2 === 0}
              hasCheckedMessage={index % 2 === 0}
              role="printer"
            />
          ))}
        </>
      ) : (
        <>
          <RoleWiseUserGroupContainer>
            <div className="group-title-wrapper">
              <Typography>Auto CAD Technician</Typography>
              <Typography variant="caption" fontColor="disableButton">
                12 peoples
              </Typography>
            </div>
            <div className="users-container">
              {messageData.map((data, index) => (
                <IndividualUserMessageWrapper
                  key={index}
                  onclick={() =>
                    changeVisibleScreen && changeVisibleScreen('conversation')
                  }
                  name={data.name}
                  lastMessage={data.lastMessage}
                  lastMessageDate={data.lastMessageDate}
                  isOnline={index % 2 === 0}
                  hasCheckedMessage={index % 2 === 0}
                  role="technician"
                />
              ))}

              <Button variant="white" size="xs" style={{ padding: '0px 3px' }}>
                See 10 others
              </Button>
            </div>
          </RoleWiseUserGroupContainer>
          <RoleWiseUserGroupContainer>
            <div className="group-title-wrapper">
              <Typography>Printer</Typography>
              <Typography variant="caption" fontColor="disableButton">
                6 peoples
              </Typography>
            </div>
            <div className="users-container">
              {messageData.map((data, index) => (
                <IndividualUserMessageWrapper
                  key={index}
                  onclick={() =>
                    changeVisibleScreen && changeVisibleScreen('conversation')
                  }
                  name={data.name}
                  lastMessage={data.lastMessage}
                  lastMessageDate={data.lastMessageDate}
                  isOnline={index % 2 === 0}
                  hasCheckedMessage={index % 2 === 0}
                  role="printer"
                />
              ))}

              <Button variant="white" size="xs" style={{ padding: '0px 3px' }}>
                See 4 others
              </Button>
            </div>
          </RoleWiseUserGroupContainer>
          <RoleWiseUserGroupContainer>
            <div className="group-title-wrapper">
              <Typography>Draftman</Typography>
              <Typography variant="caption" fontColor="disableButton">
                2 peoples
              </Typography>
            </div>
            <div className="users-container">
              {messageData.map((data, index) => (
                <IndividualUserMessageWrapper
                  key={index}
                  onclick={() =>
                    changeVisibleScreen && changeVisibleScreen('conversation')
                  }
                  name={data.name}
                  lastMessage={data.lastMessage}
                  lastMessageDate={data.lastMessageDate}
                  isOnline={index % 2 === 0}
                  hasCheckedMessage={index % 2 === 0}
                  role="draftman"
                />
              ))}
            </div>
          </RoleWiseUserGroupContainer>
          <RoleWiseUserGroupContainer>
            <div className="group-title-wrapper">
              <Typography>Fire Team</Typography>
              <Typography variant="caption" fontColor="disableButton">
                2 peoples
              </Typography>
            </div>
            <div className="users-container">
              {messageData.map((data, index) => (
                <IndividualUserMessageWrapper
                  key={index}
                  onclick={() =>
                    changeVisibleScreen && changeVisibleScreen('conversation')
                  }
                  name={data.name}
                  lastMessage={data.lastMessage}
                  lastMessageDate={data.lastMessageDate}
                  isOnline={index % 2 === 0}
                  hasCheckedMessage={index % 2 === 0}
                  role="fireTeam"
                />
              ))}
            </div>
          </RoleWiseUserGroupContainer>
        </>
      )}
    </UserListContainer>
  );
};

export default UserList;
